/*
 * ******************************************************************
 * Copyright (c) 2017-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component, Input } from "@angular/core";
import { BaseDialog } from "../base-dialog";

// @formatter:off
@Component({
    standalone: false,
    selector: 'dr-message-dialog',
    templateUrl: 'message-dialog.html',
    styleUrls: ['message-dialog.scss']
})
// @formatter:on

export class MessageDialog extends BaseDialog {
    @Input() title: string;
    @Input() message: string;
    @Input() iconShape: string;
    @Input() confirmationBtnText: string = "dialog.button.Ok";
    @Input() confirmationBtnStyle: string = "btn-primary";
    @Input() innerHTML: boolean = false;
    @Input() messageParams: any[] = [];
    @Input() titleParams: any[] = [];
}
